export default {
  useMockRenewToken: process.env.VUE_APP_USE_MOCK_RENEW_TOKEN == true,
  useMockToken: process.env.VUE_APP_USE_MOCK_TOKEN
}
